/* ===== Product data (real product photos from qualityimprint.com) ===== */
const PRODUCTS = [
  {
    name:"Confetti Stadium Cup (17 oz)",
    id:"Q385365",
    price:"0.83",
    img:"https://qualityimprint-dev.myshopify.com/cdn/shop/products/Q385365-cups-with-logo-8.jpg?v=1682264901",
    badges:[{c:"blue",t:"MADE IN USA"}],
    swatches:["#F4A52A","#E84C88","#3FA9F5","#9BD37E","#F2B6B6","#B19CD9","#FF8C42","#C8A678"]
  },
  {
    name:"Ceramic Budget Mug (11 oz.)",
    id:"Q316311",
    price:"1.32",
    img:"https://qualityimprint-dev.myshopify.com/cdn/shop/products/Q316311-mugs-with-logo-3.jpg?v=1682257826",
    badges:[{c:"red",t:"ON SALE"},{c:"green",t:"NEW"}],
    swatches:["#ffffff","#f0f0f0"],
    pricingDetails:true,
    minQty:"144"
  },
  {
    name:"Colored Budget Mug (11 oz.)",
    id:"Q276311",
    price:"2.10",
    img:"https://qualityimprint-dev.myshopify.com/cdn/shop/products/Q276311-mugs-with-logo-1.jpg?v=1682257826",
    badges:[{c:"green",t:"ECO FRIENDLY"}],
    swatches:["#9BD37E","#E8B339","#1c1c1c","#1E2B5E","#d4c5a8","#0F3D2E","#7CB342","#5E1818"],
    more:"+1"
  },
  {
    name:"Ceramic Beer Stein Mug (20 oz)",
    id:"Q299235",
    price:"2.46",
    img:"https://qualityimprint-dev.myshopify.com/cdn/shop/products/Q299235-mugs-with-logo-1.jpg?v=1682257826",
    badges:[],
    swatches:["#ffffff","#f0f0f0"]
  }
];

/* ===== Render product card ===== */
function productCard(p){
  const badges = (p.badges||[]).map(b=>`<span class="badge badge-${b.c}">${b.t}</span>`).join('');
  const swatches = (p.swatches||[]).slice(0,8).map(c=>`<span class="pc-swatch" style="background:${c}"></span>`).join('');
  const more = p.more ? `<span class="pc-swatch-more">${p.more}</span>` : '';
  const pricingLink = p.pricingDetails ? `<a href="#" class="pc-pricing-link">Pricing Details</a>` : '';
  const minQty = p.minQty ? `<div class="pc-min-qty">(Mininum Quantity ${p.minQty} pcs.)</div>` : '';
  const safeName = (p.name||'').replace(/"/g,'&quot;');
  return `
    <article class="product-card">
      <div class="pc-badges">${badges}</div>
      <button class="pc-save" aria-label="Save to favorites" onclick="this.classList.toggle('is-saved')">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>
      </button>
      <div class="pc-img pc-img-fallback">
        <img src="${p.img}" alt="${safeName}" loading="lazy" onerror="this.style.display='none'">
      </div>
      <div class="pc-swatches">${swatches}${more}</div>
      <div class="pc-name">${p.name}</div>
      <div class="pc-id">(${p.id})</div>
      <div class="pc-price">As low as <strong>$${p.price}</strong></div>
      ${pricingLink}
      ${minQty}
      <a href="#quote" class="btn btn-primary btn-block pc-cta">Get A Quick Quote</a>
    </article>
  `;
}

/* ===== Skeleton card ===== */
function skeletonCard(){
  return `
    <div class="skeleton-card">
      <div class="skeleton skeleton-img"></div>
      <div class="skeleton skeleton-line w70"></div>
      <div class="skeleton skeleton-line w40"></div>
      <div class="skeleton skeleton-btn"></div>
    </div>
  `;
}

/* ===== Initial paint with skeletons, then replace ===== */
(() => {
  const topGrid = document.getElementById('topProducts');
  if (!topGrid) return; // Prevent crashing if element doesn't exist on this template

  topGrid.innerHTML = Array(4).fill(0).map(skeletonCard).join('');

  setTimeout(()=>{
    topGrid.innerHTML = PRODUCTS.map(productCard).join('');
  }, 600);
})();

/* ===== Sticky header shadow on scroll ===== */
(() => {
  const header = document.querySelector('.header');
  if (!header) return;
  const onScroll = () => {
    header.classList.toggle('is-stuck', window.scrollY > 4);
  };
  window.addEventListener('scroll', onScroll, {passive:true});
  onScroll();
})();

/* ===== Hero carousel ===== */
(() => {
  const carousel = document.getElementById('heroCarousel');
  if (!carousel) return; // Prevent crashing if carousel doesn't exist on this template
  
  const slides = Array.from(carousel.querySelectorAll('.carousel-slide'));
  const dots = Array.from(carousel.querySelectorAll('.carousel-dot'));
  const prevBtn = carousel.querySelector('.carousel-arrow-prev');
  const nextBtn = carousel.querySelector('.carousel-arrow-next');
  
  if (slides.length === 0) return; // Quick exit if structural elements are absent

  const autoplayMs = parseInt(carousel.dataset.autoplay, 10) || 6000;
  let active = 0;
  let timer;

  function show(i) {
    const next = ((i % slides.length) + slides.length) % slides.length;
    if (next === active) return;
    
    slides[active].classList.remove('is-active');
    dots[active].classList.remove('is-active');
    dots[active].setAttribute('aria-selected', 'false');
    
    active = next;
    
    slides[active].classList.add('is-active');
    dots[active].classList.add('is-active');
    dots[active].setAttribute('aria-selected', 'true');
    
    const v = slides[active].querySelector('video');
    if (v) { 
      try { 
        // Ensure video metadata and data have loaded enough to alter currentTime safely
        if (v.readyState >= 2) {
          v.currentTime = 0; 
        }
        
        // Handle promise safely to bypass modern browser autoplay blocking flags
        const playPromise = v.play();
        if (playPromise !== undefined) {
          playPromise.catch(() => { /* Silence native browser media block interruptions */ });
        }
      } catch (e) {} 
    }
  }

  function start() { stop(); timer = setInterval(() => show(active + 1), autoplayMs); }
  function stop() { if (timer) clearInterval(timer); }

  dots.forEach((d, i) => d.addEventListener('click', () => { show(i); start(); }));
  if (prevBtn) prevBtn.addEventListener('click', () => { show(active - 1); start(); });
  if (nextBtn) nextBtn.addEventListener('click', () => { show(active + 1); start(); });
  
  carousel.addEventListener('mouseenter', stop);
  carousel.addEventListener('mouseleave', start);
  carousel.addEventListener('focusin', stop);
  carousel.addEventListener('focusout', start);

  start();
})();

/* ===== Mobile menu ===== */
(() => {
  const drawer = document.getElementById('menuDrawer');
  const overlay = document.getElementById('menuOverlay');
  const openBtn = document.getElementById('menuOpen');
  const closeBtn = document.getElementById('menuClose');

  if (!drawer || !overlay || !openBtn || !closeBtn) return; // Prevent breaking on pages without mobile navigation layouts

  function openMenu(){
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    drawer.setAttribute('aria-hidden','false');
  }
  
  function closeMenu(){
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    drawer.setAttribute('aria-hidden','true');
  }
  
  openBtn.addEventListener('click', openMenu);
  closeBtn.addEventListener('click', closeMenu);
  overlay.addEventListener('click', closeMenu);
  
  drawer.querySelectorAll('a').forEach(a => a.addEventListener('click', closeMenu));
  
  document.addEventListener('keydown', (e) => { 
    if (e.key === 'Escape') closeMenu(); 
  });
})();